/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import classNames from 'classnames';
import PropTypes from "prop-types";
import React from 'react';
import { EuiStepHorizontal } from './step_horizontal';
export var EuiStepsHorizontal = ({
  className,
  steps,
  ...rest
}) => {
  const classes = classNames('euiStepsHorizontal', className);
  return <ol className={classes} {...rest}>
      {steps.map((stepProps, index) => {
      const isCurrent = stepProps.status === 'current' ? {
        'aria-current': 'step'
      } : {};
      return <li key={index} className="euiStepHorizontal__item" {...isCurrent}>
            <EuiStepHorizontal step={index + 1} {...stepProps} />
          </li>;
    })}
    </ol>;
};
EuiStepsHorizontal.propTypes = {
  /**
     * An array of `EuiStepHorizontal` objects excluding the `step` prop
     */
  steps: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};

try {
  EuiStepsHorizontal.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/steps/steps_horizontal.tsx',
    description: '',
    displayName: 'EuiStepsHorizontal',
    methods: [],
    props: {
      steps: {
        defaultValue: null,
        description: 'An array of `EuiStepHorizontal` objects excluding the `step` prop',
        name: 'steps',
        parent: {
          fileName: 'app/src/components/steps/steps_horizontal.tsx',
          name: 'EuiStepsHorizontalProps'
        },
        declarations: [{
          fileName: 'app/src/components/steps/steps_horizontal.tsx',
          name: 'EuiStepsHorizontalProps'
        }],
        required: true,
        type: {
          name: 'Omit<EuiStepHorizontalProps, "step">[]'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['EuiStepsHorizontalProps', 'OlHTMLAttributes', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'CommonProps']
  };
} catch (e) {}